var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "100px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "游戏组ID", prop: "package_name" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择游戏组"
                  },
                  on: { change: _vm.groupNameChange },
                  model: {
                    value: _vm.formData.game_group_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "game_group_id", $$v)
                    },
                    expression: "formData.game_group_id"
                  }
                },
                _vm._l(_vm.gameGroupList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.group_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "母包名称", prop: "package_name" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "母包名称" },
                model: {
                  value: _vm.formData.package_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "package_name", $$v)
                  },
                  expression: "formData.package_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "母包描述", prop: "package_desc" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "母包描述" },
                model: {
                  value: _vm.formData.package_desc,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "package_desc", $$v)
                  },
                  expression: "formData.package_desc"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "母包版本", prop: "package_version" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "母包版本" },
                model: {
                  value: _vm.formData.package_version,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "package_version", $$v)
                  },
                  expression: "formData.package_version"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "status", label: "母包状态" }
            },
            [
              _c(
                "el-radio-group",
                {
                  staticClass: "flex-1",
                  model: {
                    value: _vm.formData.status,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "status", $$v)
                    },
                    expression: "formData.status"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("启用")
                  ]),
                  _c("el-radio", { attrs: { label: 2, border: "" } }, [
                    _vm._v("禁用")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "chooseStatus", label: "" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "flex-1",
                      attrs: { disabled: _vm.formData.id != "" },
                      on: { change: _vm.statusChange },
                      model: {
                        value: _vm.chooseStatus,
                        callback: function($$v) {
                          _vm.chooseStatus = $$v
                        },
                        expression: "chooseStatus"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, border: "" } }, [
                        _vm._v("上传文件")
                      ]),
                      _c("el-radio", { attrs: { label: 2, border: "" } }, [
                        _vm._v("提供文件地址")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.chooseStatus == 1
            ? _c(
                "el-row",
                { staticStyle: { width: "100%", height: "auto" } },
                [
                  !_vm.formData.id
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem",
                          attrs: { label: "上传母包", prop: "package" }
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticClass: "upload-demo",
                              attrs: {
                                action: "#",
                                "auto-upload": false,
                                "on-change": _vm.handleChange,
                                "file-list": _vm.fileList,
                                "on-exceed": _vm.handleExceed,
                                limit: 1,
                                "before-upload": _vm.beforeUpload,
                                name: "file",
                                accept: ".apk"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "file",
                                    fn: function(ref) {
                                      var file = ref.file
                                      return _c("div", {}, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-name"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-document"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(file.name + "-") +
                                                _vm._s(
                                                  _vm.formatFileSize(file.size)
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "el-upload-list__item-status-label"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-upload-success el-icon-circle-check"
                                            })
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-close",
                                          on: {
                                            click: function($event) {
                                              return _vm.handleRemove(file)
                                            }
                                          }
                                        })
                                      ])
                                    }
                                  }
                                ],
                                null,
                                false,
                                3986748977
                              )
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "small", type: "primary" } },
                                [_vm._v("点击上传")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip"
                                },
                                [
                                  _vm._v("请上传大小不超过"),
                                  _c(
                                    "b",
                                    { staticStyle: { color: "#f56c6c" } },
                                    [_vm._v("1G")]
                                  ),
                                  _vm._v("格式为"),
                                  _c(
                                    "b",
                                    { staticStyle: { color: "#f56c6c" } },
                                    [_vm._v("apk")]
                                  ),
                                  _vm._v("的文件")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.chooseStatus == 2
            ? _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: "母包地址", prop: "package_path" }
                },
                [
                  _vm.formData.id
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            "popper-class": "atooltip",
                            placement: "top",
                            effect: "light"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "content",
                              attrs: { slot: "content" },
                              on: {
                                click: function($event) {
                                  return _vm.$utils.capy(
                                    _vm.formData.package_path
                                  )
                                }
                              },
                              slot: "content"
                            },
                            [_vm._v(_vm._s(_vm.formData.package_path))]
                          ),
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              clearable: "",
                              placeholder: "母包版本"
                            },
                            model: {
                              value: _vm.formData.package_path,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "package_path", $$v)
                              },
                              expression: "formData.package_path"
                            }
                          })
                        ],
                        1
                      )
                    : _c("el-input", {
                        staticClass: "path-input",
                        attrs: { clearable: "", placeholder: "文件地址" },
                        model: {
                          value: _vm.formData.package_path,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "package_path", $$v)
                          },
                          expression: "formData.package_path"
                        }
                      })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", round: "" },
              on: {
                click: function($event) {
                  return _vm.rewriteClearData(false)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "", loading: _vm.reqLoading },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }